import colors from '@/assets/theme/colors/index.ts';
import font from '@/assets/theme/font/index.ts';
import media from '@/assets/theme/media';
import size from '@/assets/theme/size';
import { Theme } from '@emotion/react';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const viteBrand = EnvVarsService.getVar<Theme['brand']>('VITE_BRAND');

const theme: Theme = {
	brandName: `brand_${viteBrand}`,
	brand: viteBrand,
	colors,
	font,
	size,
	media,
};

export default theme;
